import {CategoryAssociationModel} from '../../../shared/models/category-association.model';
import {CategoryAssociationsService} from '../../../shared/services/category-associations.service';
import {CategoryAssociationNewComponent} from '../category-association-new/category-association-new.component';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DataTableResource, DataTableTranslations} from 'angular-datatables-all-versions';
import {ToastyService} from 'ng2-toasty';
import { NgDataTableSortFormatterUtility } from '../../../shared/common/tools/ngdatatablesort-formatter.utility';

@Component({
  selector: 'app-category-association-list',
  templateUrl: './category-association-list.component.html',
  styleUrls: ['./category-association-list.component.css']
})
export class CategoryAssociationListComponent implements OnInit {

  categoryFilter = '';
  categories: any[];
  categoriesFiltered: any[];
  categoryCount = 0;
  categoryResource: DataTableResource<Object>;

  translations = <DataTableTranslations>{
    indexColumn: 'Index column',
    expandColumn: 'Expand column',
    selectColumn: 'Select column',
    paginationLimit: 'Max results',
    paginationRange: 'Result range'
  }

  private ngDataTableSortFormatterUtility = new NgDataTableSortFormatterUtility();

  constructor(private router: Router, private route: ActivatedRoute,
    private toastyService: ToastyService, private modalService: NgbModal, private service: CategoryAssociationsService) {
    this.categories = this.route.snapshot.data['categories'];
    this.categoriesFiltered = this.categories;
    this.categoryResource = new DataTableResource(this.categoriesFiltered);
  }

  ngOnInit() {
    this.categoryResource.count().then(count => this.categoryCount = count);
  }

  reloadCategories(params) {
    this.categoryResource.query(params).then(items => {
      this.categoriesFiltered = items

      this.categoriesFiltered = this.categoriesFiltered.sort((item1, item2) => {
        const sortAsc = params['sortAsc'];
        const fieldToSort = params['sortBy'];
        let firstVal = this.ngDataTableSortFormatterUtility.resolveObjectValue(fieldToSort, item1);
        let secondVal = this.ngDataTableSortFormatterUtility.resolveObjectValue(fieldToSort, item2);
    
        firstVal = firstVal ? typeof firstVal==='string' ? firstVal.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") : firstVal : '';
        secondVal = secondVal ? typeof secondVal==='string' ? secondVal.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") : secondVal : '';

        return sortAsc ?
          firstVal<secondVal ? -1 : firstVal>secondVal ? 1 : 0
          :
          firstVal<secondVal ? 1 : firstVal>secondVal ? -1 : 0;
      });
    });
  }

  onCategorySelected(id: any) {
    this.categoriesFiltered = id === 'all' ? this.categories : this.categories.filter(category => {
      return category.category.id === +id;
    });
  }

  onCategoriesFiltered(): void {
    this.categoriesFiltered = (!this.categoryFilter || 0 === this.categoryFilter.length) ?
      this.categories : this.categories.filter(category => {
        return category.name.toUpperCase().indexOf(this.categoryFilter.toUpperCase()) >= 0;
      });
  }

  onEditCategory(category: CategoryAssociationModel) {
    this.router.navigate(['/assoc_category', category.id]);
  }

  cellColor(car) {
    return 'rgb(255, 255,' + (155 + Math.floor(100 - ((car.rating - 8.7) / 1.3) * 100)) + ')';
  }

  onActivateOrDeactivateCategory(category: CategoryAssociationModel): void {
    this.service.activateOrDeactivate(category).subscribe(
      data => {
        this.categoriesFiltered.filter((item) => item.id === data.id).forEach(function(item) {
          item.is_active = data.is_active;
        });

        // reload table
        this.categoryResource = new DataTableResource(this.categoriesFiltered);
        this.reloadCategories({sortBy: 'name', sortAsc: true});

        // notify user
        const verb = data.is_active ? 'activ&eacute;e' : 'desactiv&eacute;e';
        this.toastyService.success({
          title: 'Success',
          msg: 'Cat&eacute;gorie ' + verb,
          showClose: true,
          timeout: 5000,
          theme: 'bootstrap',
        });
      },
      err => this.toastyService.error({
        title: 'Attention',
        msg: 'Une erreur s\'est produite, reessayer plus tard',
        showClose: true,
        timeout: 5000,
        theme: 'bootstrap',
      })
    );
  }

  onCreate() {
    const modalRef = this.modalService.open(CategoryAssociationNewComponent);

    modalRef.result.then((result) => {
      console.log('result', result);
      if ('assoc-modal-success' === result) {
        // fetch new categories list
        this.service.list().subscribe(data => {
          this.categories = data;
          this.categoriesFiltered = data;
          this.categoryResource = new DataTableResource(this.categoriesFiltered);
          // reload table
          this.reloadCategories({sortBy: 'name', sortAsc: true});
        });

        this.toastyService.success({
          title: 'Success',
          msg: 'Cat&eacutegorie cr&eacute&eacutee',
          showClose: true,
          timeout: 5000,
          theme: 'bootstrap',
        })
      }
    }, err => console.log('error', err));
  }

}
